<script setup lang="ts">
import {ref, watch} from 'vue';
import {MarkOwnerType} from '@/core/interface/api-interface';
import { RadioItemType } from '@/ui/radio-choice/type';
import useInternalization from '@/composables/internalizable';
import useCountry from '@/composables/countryDependable';

const individualConfig = [
    {
        type: RadioItemType.IMAGE,
        text: 'Individual',
        src: '/img/individual-owner.png'
    }];

const companyConfig = [
    {
        type: RadioItemType.IMAGE,
        text: 'Company',
        src: '/img/company-owner.png'
    }];

interface Props {
    modelValue: MarkOwnerType | null;
}

const country = useCountry();
const { trans } = useInternalization(country);
const props = defineProps<Props>();
const emit = defineEmits(['update:modelValue']);

const individual = ref(props.modelValue === MarkOwnerType.PERSON);
const company = ref(props.modelValue === MarkOwnerType.BUSINESS);

watch(individual, (newValue) => {
    if (newValue) {
        emit('update:modelValue', MarkOwnerType.PERSON);
    }
})

watch(company, (newValue) => {
    if (newValue) {
        emit('update:modelValue', MarkOwnerType.BUSINESS);
    }
})

watch(() => props.modelValue, (newValue) => {
    if (newValue === MarkOwnerType.PERSON) {
        individual.value = true;
        company.value = false;
        return;
    }

    if (newValue === MarkOwnerType.BUSINESS) {
        company.value = true;
        individual.value = false;
        return;
    }

    company.value = false;
    individual.value = true;
})

</script>

<template>
    <StfSubHeading class="mb-2">The Owner of the trademark is a:</StfSubHeading>
    <StfRow>
        <StfCol col="12" colDesktop="auto">
            <StfRadioChoice v-model="individual" title="Individual(s)" size="large" :items="individualConfig" color="primary" inverted subtitle="E.g Jane Smith"/>
        </StfCol>
        <StfCol col="12" colDesktop="auto">
            <StfRadioChoice v-model="company" title="Company" size="large" :items="companyConfig" color="primary" inverted :subtitle="trans('message.contact.companyNameExample')"/>
        </StfCol>
    </StfRow>
</template>
